// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as MapSlider from "./MapSlider.bs.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as MmiDivIcons$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/map-my-India/presentation/view/MmiDivIcons.bs.js";
import * as OrderMapMenuComponent from "./OrderMapMenuComponent.bs.js";
import * as FomDateInputTs$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FomDateInputTs.bs.js";
import * as FormKeyInputTimeTs$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormKeyInputTimeTs.bs.js";

function getSliderIcon(order_status) {
  switch (order_status) {
    case /* Open */0 :
        return null;
    case /* Allocated */1 :
    case /* Accepted */2 :
        return React.createElement(MmiDivIcons$Catalyst.SliderTruck.make, {});
    case /* Live */3 :
        return React.createElement(MmiDivIcons$Catalyst.SliderTruckLive.make, {});
    case /* Loading */4 :
        return React.createElement(MmiDivIcons$Catalyst.PickupLocation.make, {});
    case /* Unloading */5 :
        return React.createElement(MmiDivIcons$Catalyst.DropLocation.make, {});
    case /* Ended */6 :
    case /* Completed */7 :
        return React.createElement(MmiDivIcons$Catalyst.EndTrip.make, {});
    case /* Cancelled */8 :
    case /* Rescheduled */9 :
        return React.createElement(MmiDivIcons$Catalyst.CancelTrip.make, {});
    
  }
}

function VehicleTracerComponent(Props) {
  var setInterpolationTime = Props.setInterpolationTime;
  var order_status = Props.order_status;
  var hamburgerMenuHandler = Props.hamburgerMenuHandler;
  var time_stamp = Props.time_stamp;
  var min_date = Props.min_date;
  var max_date = Props.max_date;
  var match = React.useState(function () {
        return time_stamp;
      });
  var handleTimeChange = match[1];
  var selectedTime = match[0];
  React.useEffect((function () {
          Curry._1(setInterpolationTime, selectedTime);
          
        }), [selectedTime]);
  return React.createElement("div", {
              className: "vehicle-tracer-container"
            }, React.createElement("div", {
                  className: "date-time-container"
                }, React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "vehicle-slider-container"
                    }, React.createElement(MmiDivIcons$Catalyst.AcceptTrip.make, {}), React.createElement(MapSlider.make, {
                          startTs: min_date,
                          endTs: max_date,
                          totalMarks: 3,
                          className: "map-slider",
                          value: time_stamp,
                          onChange: (function (param, value) {
                              return Curry._1(handleTimeChange, (function (param) {
                                            return value;
                                          }));
                            })
                        }), getSliderIcon(order_status)), React.createElement("div", {
                      className: "separator"
                    }), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(FormKeyInputTimeTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("Time", (function (param) {
                                  
                                }), undefined, undefined, "08:00 AM", undefined, undefined, undefined, undefined, undefined, "map-time-picker", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          time_props: {
                            value: Caml_option.some(selectedTime),
                            onChange: (function (date) {
                                if (date === undefined) {
                                  return ;
                                }
                                var date$1 = Caml_option.valFromOption(date);
                                return Curry._1(handleTimeChange, (function (param) {
                                              return date$1;
                                            }));
                              }),
                            format: "hh:mm:ss a",
                            ampm: true,
                            isDisabled: false
                          }
                        }), React.createElement("div", {
                          className: "separator"
                        }), React.createElement(FomDateInputTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("Date", (function (param) {
                                  
                                }), Timestamp$Catalyst.day(min_date) === Timestamp$Catalyst.day(max_date), undefined, undefined, undefined, undefined, undefined, undefined, undefined, "map-date-picker", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          date_props: {
                            value: Caml_option.some(time_stamp),
                            minDate: Caml_option.some(min_date),
                            maxDate: Caml_option.some(max_date),
                            onChange: Curry.__1(setInterpolationTime),
                            format: "DD/MM/YY",
                            autoOk: false,
                            views: [
                              "year",
                              "month",
                              "date"
                            ],
                            disableToolbar: true
                          }
                        }), React.createElement(OrderMapMenuComponent.make, {
                          hamburgerMenuHandler: hamburgerMenuHandler
                        }))));
}

var make = VehicleTracerComponent;

export {
  getSliderIcon ,
  make ,
  
}
/* react Not a pure module */
